import React, { useCallback, useEffect, useRef } from "react";

import {
  IDelegatingErrorBoundaryConfig,
  IReportingErrorBoundaryConfig,
  IReportingErrorBoundaryProps
} from "../types/IDelegatingErrorBoundary";

/**
 * Wraps the delegated child boundary with appropriate reporting side-effect behaviors.
 */
const ReportingDelegatingErrorBoundary: React.FC<
  IDelegatingErrorBoundaryConfig & IReportingErrorBoundaryProps & IReportingErrorBoundaryConfig
> = ({ bearerToken, flowId, contactId, DelegatedErrorBoundary, Fallback, useReportError, children }) => {
  const hookArgsRef = useRef({ flowId, contactId, bearerToken });
  useEffect(() => {
    hookArgsRef.current = { flowId, contactId, bearerToken };
  }, [flowId, contactId, bearerToken]);

  const { execute } = useReportError();
  const onError = useCallback(() => {
    if (hookArgsRef.current.flowId && hookArgsRef.current.contactId && hookArgsRef.current.bearerToken)
      execute({
        flowId: hookArgsRef.current.flowId,
        contactId: hookArgsRef.current.contactId,
        bearerToken: hookArgsRef.current.bearerToken
      });
  }, []);

  return (
    <DelegatedErrorBoundary onError={onError} Fallback={Fallback}>
      {children}
    </DelegatedErrorBoundary>
  );
};

export default ReportingDelegatingErrorBoundary;
